// import { useEffect, useState } from 'react';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
// import { randomHexColorWithArray } from 'random-hex-color-generator';
// import ReturnRatioTooltip from './ReturnRatio.Tooltip';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { changeTab } from '../../../../Features/reportAnalysisSlice';

function ReturnRatioGraph({ returnRatioData }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleButtonClick = () => {
        dispatch(changeTab('sales'));
        navigate('/report-and-analytics');
    }

    // const [colors, setColors] = useState([]);

    // useEffect(() => {
    //     const colorsArray = randomHexColorWithArray(returnRatioData.length);
    //     setColors(colorsArray);
    // }, [returnRatioData]);

    return (
        <div className="border rounded-lg border-[#EAEAEA] col-span-1 min-h-[50vh] p-5 flex flex-col gap-4">
            <div className="flex items-center justify-between">
                <h1 className="font-semibold text-base">Return Ratio</h1>

                <button onClick={handleButtonClick} className="p-0 outline-none border-none text-[#1055EB] font-semibold text-[12px] leading-6" href="/">View all data</button>
            </div>

            <div className="m-auto">
                <h1 className='font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>
            
            {/* <ResponsiveContainer width="100%" height="100%">
                <BarChart 
                    data={returnRatioData} 
                    margin={{
                        top: 10,
                        right: 20,
                        bottom: 10,
                        left: 0,
                    }}
                >
                    <XAxis 
                        dataKey="name" 
                        tickLine={false} 
                        tickMargin={15} 
                        type='category' 
                    />

                    <YAxis 
                        tickCount={5} 
                        tickLine={false} 
                        tickMargin={15} 
                        type="number" 
                        unit={'%'} 
                        domain={[0, 100]} 
                    />

                    <Tooltip 
                        cursor={{ fill: 'transparent' }} 
                        content={<ReturnRatioTooltip />}
                    />
                    
                    <Bar
                        dataKey="percentage"
                        fill="#00a0fc" 
                    >
                        {
                            returnRatioData.map((entry, index) => (
                                <Cell 
                                    key={`cell-${index}`} 
                                    fill={colors[index % 20]} 
                                />
                            ))
                        }
                    </Bar>
                </BarChart>
            </ResponsiveContainer> */}
        </div>
    );
}

export default ReturnRatioGraph;
